import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

export default function UserMenu() {
  const { status, user, refresh } = useAuth();
  const navigate = useNavigate();

  if (status === 'loading') return <span className="text-sm text-slate-400">...</span>;

  if (status === 'anonymous' || !user) {
    return (
      <Link
        to="/login"
        className="rounded bg-slate-900 px-3 py-1.5 text-white transition hover:bg-slate-700"
        data-testid="user-menu-login"
      >
        登录
      </Link>
    );
  }

  const initial = user.name?.trim().charAt(0) ?? '?';

  async function logout() {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    await refresh();
    navigate('/login', { replace: true });
  }

  return (
    <span
      className="flex items-center gap-2 whitespace-nowrap md:gap-3"
      data-testid="user-menu-logged-in"
    >
      <Link
        to="/account/settings"
        className="hidden text-xs text-slate-500 transition hover:text-slate-900 md:inline"
        data-testid="user-menu-settings"
      >
        设置
      </Link>
      <span className="flex items-center gap-2">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-900 text-xs font-medium text-white">
          {initial}
        </span>
        <span className="hidden text-sm text-slate-900 md:inline">{user.name}</span>
      </span>
      <button
        type="button"
        onClick={logout}
        className="hidden text-xs text-slate-500 transition hover:text-slate-900 md:inline"
        data-testid="user-menu-logout"
      >
        退出登录
      </button>
    </span>
  );
}
